
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  components: {},
})
export default class JoinSteps extends Vue {
  @Prop(Number) showStep!: number | string
  stepInfo = [
    {
      activeIcon: require('../../assets/image/step1-active.png'),
      finishIcon: require('../../assets/image/step1-finish.png'),
      text: '选择入驻类型\n并阅读入驻协议',
    },
    // {
    //   icon: require('../../assets/image/step2.png'),
    //   activeIcon: require('../../assets/image/step2-active.png'),
    //   finishIcon: require('../../assets/image/step2-finish.png'),
    //   text: '阅读入驻协议',
    // },
    {
      icon: require('../../assets/image/step3.png'),
      activeIcon: require('../../assets/image/step3-active.png'),
      finishIcon: require('../../assets/image/step3-finish.png'),
      text: '填写资质信息',
    },
    {
      icon: require('../../assets/image/step3.png'),
      activeIcon: require('../../assets/image/step3-active.png'),
      finishIcon: require('../../assets/image/step3-finish.png'),
      text: '填写财务信息',
    },
    {
      icon: require('../../assets/image/step3.png'),
      activeIcon: require('../../assets/image/step3-active.png'),
      finishIcon: require('../../assets/image/step3-finish.png'),
      text: '填写经营信息',
    },
    {
      icon: require('../../assets/image/step6.png'),
      activeIcon: require('../../assets/image/step6-active.png'),
      text: '提交审核',
    },
  ]
}
